
export const curriculum = {
  // Hero Section
  programBadge: 'EDUSPACE Problem Solving Class',
  heroTitle: '8-Week Program',
  heroSubtitle: 'Space Problem-Solving Learning for Elementary Grades 4-5',
  badge1: 'Elementary Grades 4-5',
  badge2: '8-Week Course',
  badge3: '7 Space Topics',
  badge4: 'Final Project',

  // Daily Schedule Section
  dailyScheduleTitle: 'Weekly Learning Structure',
  dailyScheduleSubtitle: 'A systematic learning program with different skills each day',

  monday: 'Monday',
  mondayFocus: 'Study Skills & Questioning',
  mondayDescription: 'Learn critical thinking and effective questioning techniques',

  tuesday: 'Tuesday',
  tuesdayFocus: 'Orienteering & Research',
  tuesdayDescription: 'Master how to find and analyze information',

  wednesday: 'Wednesday',
  wednesdayFocus: 'Space & Problem Solving',
  wednesdayDescription: 'Work on projects solving real space problems',

  thursday: 'Thursday',
  thursdayFocus: 'Tech & Production',
  thursdayDescription: 'Build and implement your ideas',

  friday: 'Friday',
  fridayFocus: 'Writing & Communication',
  fridayDescription: 'Organize and effectively present what you learned',

  // Weekly Topics Section
  weeklyTopicsTitle: '8-Week Learning Topics',
  weeklyTopicsSubtitle: 'Complete curriculum covering all areas of space exploration',

  // Week 1
  week1Title: 'Earth Science',
  week1Description: 'Explore Earth\'s systems, atmosphere, and climate through hands-on investigations',
  week1Day1: 'Monday: Understanding Earth systems - questions and exploration',
  week1Day2: 'Tuesday: Climate data research and investigation',
  week1Day3: 'Wednesday: Environmental problem-solving project',
  week1Day4: 'Thursday: Data visualization creation',
  week1Day5: 'Friday: Present and discuss findings',

  // Week 2
  week2Title: 'The Moon',
  week2Description: 'Study lunar phases, geology, and plan a Moon base mission',
  week2Day1: 'Monday: Exploring lunar characteristics',
  week2Day2: 'Tuesday: Research lunar exploration history',
  week2Day3: 'Wednesday: Begin Moon base design',
  week2Day4: 'Thursday: Create 3D models and prototypes',
  week2Day5: 'Friday: Present Moon base plans',

  // Week 3
  week3Title: 'Space Rovers',
  week3Description: 'Design, build, and test your own Mars exploration rover',
  week3Day1: 'Monday: Understand rover functions and purposes',
  week3Day2: 'Tuesday: Research real rover examples',
  week3Day3: 'Wednesday: Rover design and problem solving',
  week3Day4: 'Thursday: Rover construction and programming',
  week3Day5: 'Friday: Rover testing and presentation',

  // Week 4
  week4Title: 'Mars Exploration',
  week4Description: 'Plan a Mars mission covering habitat, resources, and survival',
  week4Day1: 'Monday: Understanding Mars environment',
  week4Day2: 'Tuesday: Research Mars exploration missions',
  week4Day3: 'Wednesday: Develop survival strategies',
  week4Day4: 'Thursday: Create Mars base model',
  week4Day5: 'Friday: Present mission plans',

  // Week 5
  week5Title: 'Life in Space',
  week5Description: 'Discover how astronauts live, work, and conduct experiments in space',
  week5Day1: 'Monday: Explore space living conditions',
  week5Day2: 'Tuesday: Research ISS daily life',
  week5Day3: 'Wednesday: Design space food systems',
  week5Day4: 'Thursday: Create life support devices',
  week5Day5: 'Friday: Present space life simulation',

  // Week 6
  week6Title: 'Stars and Galaxies',
  week6Description: 'Explore stellar lifecycles, constellations, and the vast universe',
  week6Day1: 'Monday: Understand types and characteristics of stars',
  week6Day2: 'Tuesday: Research galaxies and cosmic structures',
  week6Day3: 'Wednesday: Create constellation maps',
  week6Day4: 'Thursday: Build astronomical observation equipment',
  week6Day5: 'Friday: Present space exploration',

  // Week 7
  week7Title: 'AI in Space',
  week7Description: 'Learn how artificial intelligence helps explore and understand space',
  week7Day1: 'Monday: Understand AI basic concepts',
  week7Day2: 'Tuesday: Research AI applications in space exploration',
  week7Day3: 'Wednesday: Design simple AI models',
  week7Day4: 'Thursday: Space data analysis project',
  week7Day5: 'Friday: Present AI project',

  // Week 8
  week8Title: 'Final Project',
  week8Description: 'Showcase everything you\'ve learned in a comprehensive space mission project',
  week8Day1: 'Monday: Select and plan project topic',
  week8Day2: 'Tuesday: In-depth research and data collection',
  week8Day3: 'Wednesday: Project creation and experimentation',
  week8Day4: 'Thursday: Prepare presentation materials',
  week8Day5: 'Friday: Final presentation and graduation ceremony',

  // Common
  weekLabel: 'Week',
  seeDetails: 'See details',
  collapse: 'Collapse',
  weeklyActivities: 'Weekly Activities:',

  // Program Features Section
  programFeaturesTitle: 'What Makes EDUSPACE Special',
  programFeaturesSubtitle: 'Real project-based learning to develop problem-solving skills',

  feature1Title: 'Hands-On Learning',
  feature1Description: 'Experiential classes where students create and experiment every day',

  feature2Title: 'Small Groups',
  feature2Description: 'Small classes enabling personalized feedback',

  feature3Title: 'Complete Materials',
  feature3Description: 'Perfect materials including worksheets, quizzes, and project guides',

  feature4Title: 'Presentation Skills',
  feature4Description: 'Strengthen communication skills through weekly presentations',

  // CTA Section
  ctaBadge: 'For Elementary Grades 4-5',
  ctaTitle: 'Explore Space',
  ctaHighlight: 'with EDUSPACE',
  ctaSubtitle: '8-Week Problem-Solving Program',
  ctaDescription: 'Apply now and nurture your dream of becoming a space scientist',
  ctaButton1: 'Apply for Program',
  ctaButton2: 'View Student Projects'
};
